import React, { useState } from 'react';
import backgroundImage from "../../assets/images/solarpower.jpg";
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import "../solarplants/SolarPlants.css";
import solar1 from "../../assets/images/scard1.webp";
import solar2 from "../../assets/images/scard2.jpg";
import solar3 from "../../assets/images/scard3.webp";
import solar9 from "../../assets/images/scard4.jpg";
import solar10 from "../../assets/images/adv2.jpg";
import solar11 from "../../assets/images/adv3.jpg";
import solar5 from "../../assets/images/scard5.jpg";
import solar6 from "../../assets/images/scard6.jpeg";
import solar7 from "../../assets/images/scard6.jpg";
import newSolar1 from "../../assets/images/newSolar-1.png";
import newSolar2 from "../../assets/images/newSolar-2.png";
import newSolar3 from "../../assets/images/newSolar-3.png";
import newSolar4 from "../../assets/images/newSolar-4.png";
import newSolar5 from "../../assets/images/newSolar-5.png";
import newSolar6 from "../../assets/images/newSolar-6.png";
import newSolar7 from "../../assets/images/newSolar-7.png";
import newSolar8 from "../../assets/images/newSolar-8.png";

import { Helmet } from 'react-helmet';
import axios from 'axios';
import {
  FaCheckCircle,
  FaTimesCircle,
  FaSolarPanel,
  FaBolt,
  FaTools,
  FaDraftingCompass,
  FaShieldAlt,
} from "react-icons/fa";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SolarPlants = () => {
  const sectionStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundColor: '#a20000',
    backgroundBlendMode: 'multiply',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '550px',
    height: 'auto',
    width: "100%",
    display: 'flex',
    alignItems: 'center',
    padding: '40px 0',
  };

  const cardData = [
    {
      id: 1,
      image: solar1,
      heading: 'PM-KUSUM',
      text: 'Solar power solutions under the PM-KUSUM scheme for farmers and eligible institutions to support decentralized solar energy generation and clean electricity adoption.',
    },
    {
      id: 2,
      image: solar2,
      heading: 'RESIDENTIAL (HOME)',
      text: 'Rooftop solar solutions for homes designed to help homeowners generate clean electricity, reduce monthly power bills, and increase energy independence.',
    },
    {
      id: 3,
      image: solar3,
      heading: 'COMMERCIAL',
      text: 'Solar energy solutions for commercial establishments to reduce electricity costs, improve energy efficiency, and meet clean energy requirements.',
    },
  ];

  const tabsData = [
    {
      title: 'Guaranteed Power Generation',
      content: 'Solar Modules are the most critical component of any Solar Power Plant, which directly impacts power generation and reliability. Gautam Solar Modules are manufactured using A++ Raw Materials, Top of Line Machines, and using patented processes so that maximum power is generated for its customers.',
      image: solar9,
    },
    {
      title: 'Access to Latest Technology',
      content: 'Solar Modules are rapidly changing technology with higher cell efficiencies being launched quickly and technology changing fast. By getting EPC done from a Solar Module Manufacturer, you get access to the Latest Technology. By procuring Modules & EPC Services from Gautam Solar, you can be assured of guaranteed Warranty.',
      image: solar10,
    },
    {
      title: 'Warranty Support for Solar Power Plant',
      content: 'As Gautam Solar Modules are used in the solar power plant, we have our own Manufacturing and we do not have to coordinate with any other vendor for warranty support. This becomes especially relevant as Module technologies keep on changing very fast and warranty support for older technology modules may or may not be available with the EPC vendor. Also many inexperienced solar companies have not been able to honor warranties as their modules were not manufactured in India but procured from China.',
      image: solar11,
    },
  ];

  const [selectedImage, setSelectedImage] = useState(tabsData[0].image);
  const [clickedTabIndex, setClickedTabIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const handleTextClick = (index) => {
    setSelectedImage(tabsData[index].image);
    setClickedTabIndex(index);
  };

  const projectData = [
    {
      id: 1,
      image: solar5,
      heading: 'Bhopal Airport (Raja Bhoj Airport)',
    },
    {
      id: 2,
      image: solar6,
      heading: '70 MW in North India',
    },
    {
      id: 3,
      image: solar7,
      heading: '10 MW in Uttarkashi',
    },
    {
      id: 4,
      image: newSolar1,
      heading: '19 MW in Hilly terrains of Uttarkashi',
    },
    {
      id: 5,
      image: newSolar2,
      heading: '11 MW in Maharashtra',
    },
    {
      id: 6,
      image: newSolar3,
      heading: '23 MW in West Bengal',
    },
    {
      id: 7,
      image: newSolar4,
      heading: '10 MW in Chandigarh',
    },
    {
      id: 8,
      image: newSolar5,
      heading: '15 MW in Kerala',
    },
    {
      id: 9,
      image: newSolar6,
      heading: '18 MW in Meghalaya',
    },
    {
      id: 10,
      image: newSolar7,
      heading: '12 MW in Vadodara,Gujarat',
    },
    {
      id: 11,
      image: newSolar8,
      heading: '12 MW in Assam',
    },
  ];

  // Form state
  const [formData, setFormData] = useState({
    fullName: '',
    companyName: '',
    mobileNumber: '',
    cityState: '',
    projectType: '',
    requiredCapacity: '',
    electricityBill: '',
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!formData.fullName || formData.fullName.trim() === '') {
        alert('Please enter your Full Name');
        return;
      } else if (formData.fullName.trim().length < 2) {
        alert('Full Name must be at least 2 characters');
        return;
      }


      if (!formData.mobileNumber || formData.mobileNumber.trim() === '') {
        alert('Please enter your Mobile Number');
        return;
      } else {
        const phoneRegex = /^[6-9]\d{9}$|^\+91[6-9]\d{9}$/;
        const cleanPhone = formData.mobileNumber.replace(/\s/g, '');
        if (!phoneRegex.test(cleanPhone) && !phoneRegex.test(cleanPhone.replace('+91', ''))) {
          alert('Please enter a valid Indian mobile number (10 digits)');
          return;
        }
      }

      if (!formData.cityState || formData.cityState.trim() === '') {
        alert('Please enter your City & State');
        return;
      }

      if (!formData.projectType || formData.projectType === '') {
        alert('Please select a Project Type');
        return;
      }

      let utm = localStorage.getItem('utm_data') || null;

      const Data = {
        fullName: formData.fullName,
        companyName: formData.companyName && formData.companyName.trim() !== '' ? formData.companyName : 'N/A',
        mobileNumber: formData.mobileNumber,
        cityState: formData.cityState,
        projectType: formData.projectType,
        requiredCapacity: formData.requiredCapacity && formData.requiredCapacity !== '' ? formData.requiredCapacity : 'N/A',
        electricityBill: formData.electricityBill || 'Not Provided',
        utm
      };
      setLoading(true);

      await axios.post('https://gautamsolar.us/solarPlant-contact', Data);

      alert('Thank you! We will get back to you soon.');
      setFormData({
        fullName: '',
        companyName: '',
        mobileNumber: '',
        cityState: '',
        projectType: '',
        requiredCapacity: '',
        electricityBill: '',
      });
    } catch (er) {
      alert('Error submitting form. Please try again later.');
      console.log(er);
    }
    finally {
      setLoading(false)
    }
  };

  // SVG Arrow Icon
  const ArrowIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );

  return (
    <>


      <Helmet>
        <title>
          Solar Power Plant Solutions in India | Gautam Solar
        </title>

        <meta
          name="description"
          content="Gautam Solar provides solar power plant solutions for commercial and industrial enterprises in India, including Open Access, Ground-Mounted, and Rooftop Solar."
        />

        <link
          rel="canonical"
          href="https://gautamsolar.com/solarplants/"
        />

        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Solar Power Plant Solutions in India | Gautam Solar"
        />

        <meta
          property="og:description"
          content="Gautam Solar provides Open Access, Ground-Mounted, and Rooftop Solar Power Plant solutions for commercial and industrial enterprises in India."
        />

        <meta
          property="og:url"
          content="https://gautamsolar.com/solarplants/"
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:site_name"
          content="Gautam Solar"
        />

        {/* =========================
      ORGANIZATION
      This identifies Gautam Solar.
      If you already have this schema
      globally/homepage, don't duplicate it.
  ========================== */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",

            "@id": "https://gautamsolar.com/#organization",

            "name": "Gautam Solar",

            "url": "https://gautamsolar.com/",

            "description":
              "Gautam Solar is an Indian solar energy company providing solar modules and solar power solutions.",

            "sameAs": [
              "https://www.facebook.com/gautamsolarprivatelimited",
              "https://www.instagram.com/gautam_solar/",
              "https://www.linkedin.com/company/gautam-solar-group/",
              "https://www.youtube.com/@GautamSolarOfficial"
            ]
          })}
        </script>

        {/* =========================
      WEBSITE
  ========================== */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",

            "@id": "https://gautamsolar.com/#website",

            "url": "https://gautamsolar.com/",

            "name": "Gautam Solar",

            "publisher": {
              "@id": "https://gautamsolar.com/#organization"
            }
          })}
        </script>

        {/* =========================
      SERVICE
      PRIMARY SCHEMA FOR THIS PAGE
  ========================== */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",

            "@id": "https://gautamsolar.com/solarplants/#service",

            "name": "Solar Power Plant Solutions",

            "url": "https://gautamsolar.com/solarplants/",

            "description":
              "Gautam Solar provides solar power plant solutions for commercial and industrial enterprises in India, including Open Access Solar, Ground-Mounted Solar Plants, and Rooftop Solar Plants.",

            "serviceType": "Solar Power Plant Solutions",

            "provider": {
              "@type": "Organization",
              "@id": "https://gautamsolar.com/#organization",
              "name": "Gautam Solar",
              "url": "https://gautamsolar.com/"
            },

            "areaServed": {
              "@type": "Country",
              "name": "India"
            },

            "hasOfferCatalog": {
              "@type": "OfferCatalog",

              "name": "Gautam Solar Power Plant Solutions",

              "itemListElement": [
                {
                  "@type": "Offer",

                  "itemOffered": {
                    "@type": "Service",

                    "@id":
                      "https://gautamsolar.com/solarplants/#open-access-solar",

                    "name": "Open Access Solar",

                    "description":
                      "Off-site solar power solutions for businesses with high electricity demand, including captive and group captive models."
                  }
                },

                {
                  "@type": "Offer",

                  "itemOffered": {
                    "@type": "Service",

                    "@id":
                      "https://gautamsolar.com/solarplants/#ground-mounted-solar",

                    "name": "Ground-Mounted Solar Plant",

                    "description":
                      "Ground-mounted solar power plant solutions for businesses with suitable land areas for captive solar power generation."
                  }
                },

                {
                  "@type": "Offer",

                  "itemOffered": {
                    "@type": "Service",

                    "@id":
                      "https://gautamsolar.com/solarplants/#rooftop-solar",

                    "name": "Rooftop Solar Plant",

                    "description":
                      "Grid-connected rooftop solar power plant solutions for commercial and industrial enterprises."
                  }
                }
              ]
            }
          })}
        </script>

        {/* =========================
      WEBPAGE
  ========================== */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",

            "@id": "https://gautamsolar.com/solarplants/#webpage",

            "url": "https://gautamsolar.com/solarplants/",

            "name":
              "Solar Power Plant Solutions in India | Gautam Solar",

            "description":
              "Solar power plant solutions from Gautam Solar for commercial and industrial enterprises in India, including Open Access, Ground-Mounted, and Rooftop Solar.",

            "inLanguage": "en",

            "isPartOf": {
              "@id": "https://gautamsolar.com/#website"
            },

            "publisher": {
              "@id": "https://gautamsolar.com/#organization"
            },

            "about": {
              "@id": "https://gautamsolar.com/solarplants/#service"
            },

            "breadcrumb": {
              "@id":
                "https://gautamsolar.com/solarplants/#breadcrumb"
            }
          })}
        </script>

        {/* =========================
      BREADCRUMB
  ========================== */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",

            "@id":
              "https://gautamsolar.com/solarplants/#breadcrumb",

            "itemListElement": [
              {
                "@type": "ListItem",

                "position": 1,

                "name": "Home",

                "item": "https://gautamsolar.com/"
              },

              {
                "@type": "ListItem",

                "position": 2,

                "name": "Solar Power Plant Solutions",

                "item":
                  "https://gautamsolar.com/solarplants/"
              }
            ]
          })}
        </script>

      </Helmet>


      <h1 className="sr-only">Solar Energy Solutions For Commercial & Industrial</h1>

      {/* ===== HERO SECTION WITH FORM ON RIGHT ===== */}
      <section style={sectionStyle}>
        <Container>
          <Row className="align-items-center" style={{ minHeight: '450px' }}>
            {/* Left Column - Title */}
            <Col lg={6} md={6} className="hero-left-col">
              <h2 className="hero-title">
                Gautam Solar<br />
                <span className="hero-subtitle">Your Energy Transition Partner</span>
              </h2>
            </Col>

            {/* Right Column - Form */}
            <Col lg={6} md={6} className="hero-right-col">
              <div className="hero-form-card">
                <div className="hero-form-banner">
                  <span>Contact Us</span>
                </div>
                <p className="hero-form-subtitle" style={{ fontSize: '13px' }}>
                  Tell us about your requirements and our experts will recommend the right solar solution.
                </p>


                <Form onSubmit={handleFormSubmit} className="hero-form">
                  {/* Full Name */}
                  <Form.Group className="form-group-custom hero-form-group">
                    <Form.Label className="form-label-custom">
                      Full Name <span className="required-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleFormChange}
                      placeholder="Your name"
                      className="form-control-custom hero-form-control"
                      required
                    />
                  </Form.Group>

                  {/* Company Name */}
                  <Form.Group className="form-group-custom hero-form-group">
                    <Form.Label className="form-label-custom">
                      Company Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleFormChange}
                      placeholder="Your company"
                      className="form-control-custom hero-form-control"
                    />
                  </Form.Group>

                  {/* Mobile Number */}
                  <Form.Group className="form-group-custom hero-form-group">
                    <Form.Label className="form-label-custom">
                      WhatsApp / Mobile Number <span className="required-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleFormChange}
                      placeholder="+91XXXXXXXXX"
                      className="form-control-custom hero-form-control"
                      required
                    />
                  </Form.Group>

                  {/* City & State */}
                  <Form.Group className="form-group-custom hero-form-group">
                    <Form.Label className="form-label-custom">
                      City & State <span className="required-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="cityState"
                      value={formData.cityState}
                      onChange={handleFormChange}
                      placeholder="e.g. Pune, Maharashtra"
                      className="form-control-custom hero-form-control"
                      required
                    />
                  </Form.Group>

                  {/* Project Type */}
                  <Form.Group className="form-group-custom hero-form-group">
                    <Form.Label className="form-label-custom">
                      Type of Project <span className="required-star">*</span>
                    </Form.Label>
                    <Form.Select
                      name="projectType"
                      value={formData.projectType}
                      onChange={handleFormChange}
                      className="form-control-custom hero-form-control"
                      required
                    >
                      <option value="">Select project type</option>
                      {/* <option value="openaccess">Open Access / Group Captive Solar</option> */}
                      <option value="rooftop">Rooftop Solar (Commercial/Industrial)</option>
                      {/* <option value="groundmount">Ground-Mounted Solar Plant</option> */}
                      <option value="pm-kusum">PM-KUSUM Scheme Project</option>
                      <option value="residential">Residential Rooftop (Home)</option>
                    </Form.Select>
                  </Form.Group>

                  {/* Capacity */}
                  <Form.Group className="form-group-custom hero-form-group">
                    <Form.Label className="form-label-custom">
                      Required Capacity / Connected Load
                    </Form.Label>
                    <Form.Select
                      name="requiredCapacity"
                      value={formData.requiredCapacity}
                      onChange={handleFormChange}
                      className="form-control-custom hero-form-control"
                    >
                      <option value="">Select capacity range</option>
                      <option value="below-100kw">Below 100 kW</option>
                      <option value="100kw-500kw">100 kW - 500 kW</option>
                      <option value="500kw-1mw">500 kW - 1 MW</option>
                      <option value="1mw-5mw">1 MW - 5 MW</option>
                      <option value="5mw-plus">5 MW+</option>
                    </Form.Select>
                  </Form.Group>

                  {/* Electricity Bill (optional) */}
                  <Form.Group className="form-group-custom hero-form-group">
                    <Form.Label className="form-label-custom">
                      Average Monthly Electricity Bill (optional)
                    </Form.Label>
                    <Form.Select
                      name="electricityBill"
                      value={formData.electricityBill}
                      onChange={handleFormChange}
                      className="form-control-custom hero-form-control"
                    >
                      <option value="">Select range</option>
                      <option value="below-100000">Below ₹1,00,000</option>
                      <option value="100000-500000">₹1,00,000 - ₹5,00,000</option>
                      <option value="500000-2000000">₹5,00,000 - ₹20,00,000</option>
                      <option value="2000000-plus">₹20,00,000+</option>
                    </Form.Select>
                  </Form.Group>

                  {/* Submit Button with Spinner */}
                  <Button
                    type="submit"
                    className="hero-form-submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <span className="btn-icon-wrapper">
                          <ArrowIcon />
                        </span>
                        Submit
                      </>
                    )}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <>

        <div
          className="py-5 fade-up border-top "
        >
          <div style={{ width: '100%' }}>
            {/* <h2 className="mb-3 textRes px-2 text-uppercase text-center">
              India’s Leading <span style={{ color: '#a20000' }}> Solar Module Plant </span>
            </h2> */}

            {/* Video Container */}
            <div
              onClick={() => setShowVideo(true)}
              className="position-relative "
              style={{
                width: '100%',
                overflow: 'hidden',
                aspectRatio: '16/9',
              }}
            >
              <video
                style={{
                  width: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.5s ease',
                }}
                loop
                autoPlay
                muted
                playsInline
                preload='auto'
                // src="/renew-X-2025-(1).mp4"
                src="/Gautam_solar_power_plants.mp4"


              ></video>

              {/* Overlay */}
              <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ background: 'rgba(0,0,0,0.15)' }}
              ></div>
            </div>
          </div>

        </div>

        {showVideo &&
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'black',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowVideo(false)}
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: 'rgba(0,0,0,0.5)',
                color: 'white',
                border: 'none',
                fontSize: '24px',
                padding: '10px',
                borderRadius: '50%',
                cursor: 'pointer',
              }}
            >
              ✕
            </button>

            <video
              src="/Gautam_solar_power_plants.mp4"
              loop
              controls
              autoPlay
              width="80%"
              height="80%"
            />
          </div>
        }

      </>

      {/* Introduction Section */}
      {/* <section className="intro-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <div className="text-center">
                <div className="section-header">
                  <span className="section-divider"></span>
                  <h2 className="section-title">
                  
                    <span className='highlight'>
                      Top 10 {" "}
                    </span>
                    <span>
                      Solar Company
                    </span>
                  </h2>
                </div>
                <img
                  src="/top-4.jpeg"
                  alt="Top 4 Solar Company"
                  style={{ width: "100%", height: "440px", objectFit: 'contain' }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      <section
        className="intro-section"
        style={{
          padding: "70px 0",
          background: "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg={11} xl={10}>
              <div
                className="text-center"
                style={{
                  background: "#ffffff",
                  borderRadius: "20px",
                  padding: "45px 35px 40px",
                  boxShadow: "0 10px 35px rgba(0, 0, 0, 0.08)",
                  border: "1px solid #eeeeee",
                }}
              >
                {/* Section Heading */}
                <div
                  className="section-header"
                  style={{
                    marginBottom: "30px",
                  }}
                >
                  <span
                    className="section-divider"
                    style={{
                      display: "block",
                      width: "65px",
                      height: "4px",
                      background: "#a20000",
                      borderRadius: "10px",
                      margin: "0 auto 15px",
                    }}
                  ></span>

                  <h2
                    className="section-title"
                    style={{
                      fontSize: "2.4rem",
                      fontWeight: "700",
                      color: "#222222",
                      margin: 0,
                      lineHeight: "1.3",
                    }}
                  >
                    <span
                      className="highlight"
                      style={{
                        color: "#a20000",
                        fontWeight: "800",
                      }}
                    >
                      Top 4 {""}
                    </span>
                    <span> Solar Company in India</span>
                  </h2>

                  <p
                    style={{
                      margin: "14px auto 0",
                      maxWidth: "750px",
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      color: "#666666",
                    }}
                  >
                    Gautam Solar has been independently ranked India's 4th largest
                    solar module manufacturer by JMK Research &amp; Analytics, reflecting
                    our growing contribution to the country's clean energy sector.
                  </p>
                </div>

                {/* Image */}
                <div
                  style={{
                    width: "100%",
                    background: "#f7f7f7",
                    borderRadius: "14px",
                    padding: "12px",
                    overflow: "hidden",
                    border: "1px solid #e8e8e8",
                  }}
                >
                  <img
                    src="/top-4.jpeg"
                    alt="Top 10 Solar Companies in India"
                    style={{
                      width: "100%",
                      height: "440px",
                      objectFit: "contain",
                      display: "block",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Range of Offering Section */}
      <section className="offerings-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="text-center mb-5">
                <div className="section-header">
                  <span className="section-divider"></span>
                  <h2 className="section-title">
                    Solar Energy Solutions For <span className="highlight">Commercial & Industrial</span>
                  </h2>
                </div>
              </div>
            </Col>
          </Row>
          <Row xs={1} md={3} className="g-4">
            {cardData.map((card) => (
              <Col key={card.id}>
                <Card className="offering-card h-100">
                  <div className="card-image-wrapper">
                    <Card.Img
                      variant="top"
                      alt={card.heading}
                      src={card.image}
                      className="offering-card-img"
                    />
                  </div>
                  <Card.Body className="text-center">
                    <Card.Title className="offering-card-title">
                      {card.heading}
                      <span className="title-underline"></span>
                    </Card.Title>
                    <Card.Text className="offering-card-text">{card.text}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Advantage Section */}
      {/* <section className="advantage-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="text-center mb-5">
                <div className="section-header">
                  <span className="section-divider"></span>
                  <h2 className="section-title">
                    Gautam Solar <span className="highlight">Advantage</span>
                  </h2>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <div className="advantage-tabs">
                {tabsData.map((tab, index) => (
                  <div
                    key={index}
                    className={`advantage-tab ${clickedTabIndex === index ? 'active' : ''}`}
                    onClick={() => handleTextClick(index)}
                  >
                    <h4 className="advantage-tab-title">{tab.title}</h4>
                    <p className="advantage-tab-content">{tab.content}</p>
                  </div>
                ))}
              </div>
            </Col>
            <Col lg={6}>
              <div className="advantage-image-wrapper">
                <img
                  src={selectedImage}
                  alt="Solar Inspection"
                  className="advantage-image"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}

      <section className="advantage-section">
        <Container>
          {/* Section Heading */}
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="text-center mb-5">
                <div className="section-header">
                  <span className="section-divider"></span>

                  <h2 className="section-title">
                    Gautam Solar{" "}
                    <span className="highlight">Advantage</span>
                  </h2>

                  <p className="advantage-intro">
                    Discover how Gautam Solar's integrated approach delivers
                    greater quality, reliability and support compared with
                    conventional EPC providers.
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Comparison */}
          <div className="advantage-comparison">

            {/* Header */}
            <div className="advantage-header">
              <div className="advantage-header-spacer"></div>

              <div className="advantage-company gautam">
                GAUTAM SOLAR
              </div>

              <div className="advantage-company other">
                OTHER EPC
              </div>
            </div>

            {/* Solar Module */}
            <div className="advantage-row">

              <div className="advantage-feature">
                <div className="feature-icon">
                  <FaSolarPanel />
                </div>

                <div>
                  <h4>Solar Module</h4>
                  <p>
                    High-quality modules backed by Gautam Solar's
                    manufacturing expertise.
                  </p>
                </div>
              </div>

              <div className="advantage-column positive">
                <FaCheckCircle className="status-icon" />

                <div>
                  <h5>In-house Manufacturing</h5>
                  <p>
                    Owned manufacturing with strict quality control
                  </p>
                </div>
              </div>

              <div className="advantage-column negative">
                <FaTimesCircle className="status-icon" />

                <div>
                  <h5>Outsourced</h5>
                  <p>
                    Dependent on warranty from manufacturer
                  </p>
                </div>
              </div>

            </div>

            {/* Inverter */}
            <div className="advantage-row">

              <div className="advantage-feature">
                <div className="feature-icon">
                  <FaBolt />
                </div>

                <div>
                  <h4>Inverter</h4>
                  <p>
                    Reliable inverter solutions selected for long-term
                    plant performance.
                  </p>
                </div>
              </div>

              <div className="advantage-column positive">
                <FaCheckCircle className="status-icon" />

                <div>
                  <h5>In-house Manufacturing</h5>
                  <p>
                    Owned manufacturing with strict quality control
                  </p>
                </div>
              </div>

              <div className="advantage-column negative">
                <FaTimesCircle className="status-icon" />

                <div>
                  <h5>Outsourced</h5>
                  <p>
                    Dependent on warranty from manufacturer
                  </p>
                </div>
              </div>

            </div>

            {/* Mounted Structure */}
            <div className="advantage-row">

              <div className="advantage-feature">
                <div className="feature-icon">
                  <FaTools />
                </div>

                <div>
                  <h4>Mounted Structure</h4>
                  <p>
                    Robust structures engineered for dependable solar
                    plant installation.
                  </p>
                </div>
              </div>

              <div className="advantage-column positive">
                <FaCheckCircle className="status-icon" />

                <div>
                  <h5>In-house Manufacturing</h5>
                  <p>
                    High structural reliability
                  </p>
                </div>
              </div>

              <div className="advantage-column negative">
                <FaTimesCircle className="status-icon" />

                <div>
                  <h5>Outsourced</h5>
                  <p>
                    Dependent on warranty from manufacturer
                  </p>
                </div>
              </div>

            </div>

            {/* Design & Engineering */}
            <div className="advantage-row">

              <div className="advantage-feature">
                <div className="feature-icon">
                  <FaDraftingCompass />
                </div>

                <div>
                  <h4>Design & Engineering</h4>
                  <p>
                    Dedicated engineering expertise for optimized
                    solar plant design.
                  </p>
                </div>
              </div>

              <div className="advantage-column positive">
                <FaCheckCircle className="status-icon" />

                <div>
                  <h5>In-house Team</h5>
                  <p>
                    In-house team with advanced software for designing
                  </p>

                  <div className="software-list">
                    <span>PVSyst</span>
                    <span>AutoCAD</span>
                    <span>SketchUp</span>
                  </div>
                </div>
              </div>

              <div className="advantage-column negative">
                <FaTimesCircle className="status-icon" />

                <div>
                  <h5>Outsourced</h5>
                  <p>
                    3rd Party / In-House with limited design control
                  </p>
                </div>
              </div>

            </div>

            {/* Warranty */}
            <div className="advantage-row last-row">

              <div className="advantage-feature">
                <div className="feature-icon">
                  <FaShieldAlt />
                </div>

                <div>
                  <h4>Warranty</h4>
                  <p>
                    Direct manufacturer support for reliable
                    long-term service.
                  </p>
                </div>
              </div>

              <div className="advantage-column positive">
                <FaCheckCircle className="status-icon" />

                <div>
                  <h5>Direct from Manufacturer</h5>
                  <p>
                    Direct warranty support, quick resolution &
                    reliable service
                  </p>
                </div>
              </div>

              <div className="advantage-column negative">
                <FaTimesCircle className="status-icon" />

                <div>
                  <h5>Dependent on Manufacturer</h5>
                  <p>
                    No ownership of warranty as different component
                    manufacturers may be involved
                  </p>
                </div>
              </div>

            </div>

          </div>
        </Container>
      </section>

      {/* Projects Section */}
      {/* <section className="projects-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="text-center mb-5">
                <div className="section-header">
                  <span className="section-divider"></span>
                  <h2 className="section-title">
                    Projects With <span className="highlight">Gautam Solar Modules</span>
                  </h2>
                </div>
              </div>
            </Col>
          </Row>
          <Row xs={1} md={3} className="g-4">
            {projectData.map((card) => (
              <Col key={card.id}>
                <Card className="project-card h-100">
                  <div className="card-image-wrapper">
                    <Card.Img
                      variant="top"
                      src={card.image}
                      className="project-card-img"
                      alt={card.heading}
                    />
                  </div>
                  <Card.Body className="text-center">
                    <span className="section-divider"></span>
                    <Card.Title className="project-card-title">{card.heading}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section> */}

      {/* <div style={{ marginTop: '2rem', overflowX: 'hidden' }}>
          <div className="carousel-wrapper px-4">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={24}

              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
            >
              {chunkedFeatures.flat().map((feature, idx) => (
                <SwiperSlide key={idx}>
                  <div
                    style={{
                      background: '#fff',
                      borderRadius: '12px',
                      padding: '1.5rem',
                      textAlign: 'center',
                      minHeight: '300px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                      height: '100%',
                    }}
                    className="border"
                  >
                    <div>{feature.icon}</div>
                    <h4 style={{ color: '#a20000', fontSize: 'clamp(1rem, 1.2vw, 1.25rem)', marginTop: '1rem' }}>
                      {feature.title}
                    </h4>
                    <hr style={{ margin: '1rem 0' }} />
                    <p style={{ fontSize: 'clamp(0.9rem, 1vw, 1rem)' }}>
                      {feature.description}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div> */}

      <section className="projects-section" style={{ padding: "70px 0", background: "#fff" }}>
        <Container>

          {/* Heading */}
          <Row className="justify-content-center">
            <Col lg={10}>
              <div style={{ textAlign: "center", marginBottom: "45px" }}>

                <div
                  style={{
                    width: "45px",
                    height: "3px",
                    background: "#a20000",
                    margin: "0 auto 12px",
                    borderRadius: "10px",
                  }}
                />

                <h2
                  style={{
                    margin: 0,
                    fontSize: "clamp(28px, 4vw, 44px)",
                    fontWeight: "600",
                    color: "#111",
                    lineHeight: "1.2",
                  }}
                >
                  Projects With{" "}
                  <span style={{ color: "#a20000" }}>
                    Gautam Solar Modules
                  </span>
                </h2>

              </div>
            </Col>
          </Row>


          {/* Project Slider */}
          <div
            style={{
              width: "100%",
              maxWidth: "1250px",
              margin: "0 auto",
              overflow: "hidden",
              padding: "10px 0 30px",
            }}
          >

            <Swiper
              modules={[Autoplay, EffectCoverflow]}

              effect="coverflow"

              centeredSlides={true}

              loop={true}

              grabCursor={true}

              slidesPerView={1.3}

              spaceBetween={0}

              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 120,
                modifier: 1.5,
                slideShadows: false,
              }}

              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}

              breakpoints={{
                320: {
                  slidesPerView: 1.15,
                  coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 80,
                    modifier: 1.3,
                    slideShadows: false,
                  },
                },

                576: {
                  slidesPerView: 1.5,
                  coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 1.4,
                    slideShadows: false,
                  },
                },

                768: {
                  slidesPerView: 2,
                  coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 120,
                    modifier: 1.5,
                    slideShadows: false,
                  },
                },

                1024: {
                  slidesPerView: 2.5,
                  coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 150,
                    modifier: 1.5,
                    slideShadows: false,
                  },
                },

                1280: {
                  slidesPerView: 3,
                  coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 180,
                    modifier: 1.5,
                    slideShadows: false,
                  },
                },
              }}
            >

              {projectData.map((project) => (
                <SwiperSlide key={project.id}>

                  {({ isActive }) => (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "400px",

                        borderRadius: "10px",

                        overflow: "hidden",

                        background: "#222",

                        boxShadow: isActive
                          ? "0 12px 35px rgba(0,0,0,0.25)"
                          : "0 5px 20px rgba(0,0,0,0.15)",

                        transition: "all 0.4s ease",
                      }}
                    >

                      {/* Project Image */}
                      <img
                        src={project.image}
                        alt={project.heading}
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />

                      {/* Dark Overlay */}
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,

                          background: isActive
                            ? "linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.05) 65%)"
                            : "rgba(0,0,0,0.45)",

                          transition: "all 0.4s ease",
                        }}
                      />

                      {/* Project Information */}
                      <div
                        style={{
                          position: "absolute",
                          left: "0",
                          right: "0",
                          bottom: "0",

                          padding: "25px",

                          textAlign: "center",

                          color: "#fff",
                        }}
                      >

                        <div
                          style={{
                            width: "45px",
                            height: "3px",
                            background: "#a20000",
                            margin: "0 auto 12px",
                            borderRadius: "10px",
                          }}
                        />

                        <h3
                          style={{
                            margin: 0,
                            color: "#fff",
                            fontSize: "clamp(18px, 2vw, 26px)",
                            fontWeight: "700",
                            textShadow: "0 2px 6px rgba(0,0,0,0.5)",
                          }}
                        >
                          {project.heading}
                        </h3>

                      </div>

                    </div>
                  )}

                </SwiperSlide>
              ))}

            </Swiper>

          </div>

        </Container>
      </section>
    </>
  );
};

export default SolarPlants;